import { render } from "./Tem030.vue?vue&type=template&id=130e9df9"
import script from "./Tem030.vue?vue&type=script&lang=js"
export * from "./Tem030.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__